import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";
import CustomSelect from "../../../../helpers/ui/CustomSelect"

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            employeeOptions: [],
            selectedEmployee: null,
            selectedEmployeeUuid:'',
            nip:'',
            nama:'',
            jabatan:'',
            polaKerjaOptions: [],
            selectedPolaKerja: null,
            isLoadingOptEmployee: true
        }
    }

    reformatOptionsEmployee = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
        //   newObj["label"] = data['employee_nip'] +' - '+ data[label];
          newObj["label"] = data[label];
          newObj["value"] = data[value];
          newObj["model"] = data;
      
          return newObj;
        });
    };

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
          newObj["model"] = data;
      
          return newObj;
        });
    };

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.dataForm.signatories_official_uuid,
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            dataForm: response,
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        // this.updateBloc.employeeChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             if(result.data.status) {
        //                 let response = result.data.response
        //                 //console.log(response)
        //                 this.setState({
        //                     employeeOptions: this.reformatOptionsEmployee(
        //                         response.result,
        //                         'employee_current_position_name',
        //                         'employee_uuid',
        //                     ),
        //                     isLoadingOptEmployee: false
        //                 })
        //             }
        //             break
        //         case apiResponse.ERROR:
                    
        //             break
        //         default:
        //             break
        //     }
        // })
        // this.updateBloc.polaKerjaChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             if(result.data.status) {
        //                 let response = result.data.response
        //                 //console.log(response)
        //                 this.setState({
        //                     polaKerjaOptions: this.reformatOptions(
        //                         response.result,
        //                         'working_pattern_name',
        //                         'working_pattern_uuid',
        //                     ),
        //                     isLoadingOptPolaKerja: false
        //                 })
        //             }
        //             break
        //         case apiResponse.ERROR:
                    
        //             break
        //         default:
        //             break
        //     }
        // })

        this.updateBloc.fetchEmployee()
        this.updateBloc.fetchPolaKerja()

        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount() {
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
        this.updateBloc.employeeChannel?.unsubscribe()
        this.updateBloc.polaKerjaChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Edit Mapping Pejabat Penetap</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="presensi_exclude_absen_employee_uuid"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pejabat Penetap <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name={`presensi_exclude_absen_employee_uuid`}
                                                    errorMessage="Pilih Pejabat Penetap"
                                                    options={this.state.employeeOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Pegawai"
                                                    isLoading={this.state.isLoadingOptEmployee}
                                                    onChange={
                                                        (v) => this.setState({
                                                            selectedEmployee: v.model,
                                                            euuid:v.model.employee_uuid,
                                                            nip:v.model.employee_nip,
                                                            nama:v.model.employee_full_name,
                                                            jabatan:v.model.employee_current_position_name,
                                                        })
                                                    }
                                                    defaultValue={this.state.euuid}
                                                />
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kode 
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="region_code"
                                                    id="region_code"
                                                    // readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    value={this.state.dataForm?.region_code}
                                                />
                                                <AvField
                                                    placeholder=""
                                                    name="uuid"
                                                    id="uuid"
                                                    // readonly="readonly"
                                                    type="hidden"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    value={this.state.dataForm?.region_uuid}
                                                />
                                                <AvField
                                                    placeholder=""
                                                    name="region_parent_uuid"
                                                    id="region_parent_uuid"
                                                    type="hidden"
                                                    value={'61b47307-167d-489f-bb6c-c1c9662acab3'}//indonesia
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Provinsi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="region_name"
                                                    id="region_name"
                                                    // readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm?.region_name}
                                                />
                                            </Col>
                                        </Row>

                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/provinsi.html?'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);